import axios from "axios";

export const fortress_login = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
});

export default axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true,
});
